/**
 * Every key the app handles, in one list, shown by Settings › Keyboard and by
 * Help (F1). Only keys that really work belong here — each row points at code
 * that handles it.
 */
export const SHORTCUTS: Array<{ group: string; rows: Array<[string, string]> }> = [
  {
    group: 'Anywhere',
    rows: [
      ['Ctrl + K', 'Find a screen or command'],
      ['F1', 'Help'],
      ['Ctrl + ,', 'Open Settings'],
      ['Ctrl + Shift + L', 'Lock the screen'],
      ['Tab / Shift + Tab', 'Move to the next or last control'],
    ],
  },
  {
    group: 'Lists',
    rows: [
      ['↑ ↓', 'Choose the row above or below'],
      ['Page Up / Page Down', 'Move ten rows'],
      ['Home / End', 'Go to the first or last row'],
      ['Enter', 'Open the chosen row'],
      ['F2', 'Edit the chosen row'],
      ['Delete', 'Delete the chosen row, where allowed'],
      ['Right-click', 'Show the actions for a row'],
    ],
  },
  {
    group: 'Folder trees',
    rows: [
      ['↑ ↓', 'Choose the item above or below'],
      ['→ ←', 'Open or close a folder'],
      ['Home / End', 'Go to the first or last item'],
    ],
  },
  {
    group: 'Pane dividers',
    rows: [
      ['← → or ↑ ↓', 'Make a pane bigger or smaller'],
      ['Enter or double-click', 'Hide or show the pane'],
    ],
  },
  {
    group: 'Tabs and dialogs',
    rows: [
      ['← →', 'Go to the next or last tab'],
      ['Esc', 'Close a dialog or menu'],
    ],
  },
  {
    group: 'Entering item lines',
    rows: [['Enter on the last line', 'Add a new line']],
  },
];
